<template>
  <div class="page-container">
    <CompanyHeader :company="currentCompany" v-if="currentCompany" />
    <div class="body__container">
      <CameraDisplay
        ref="cameraDisplay"
        :countdown="countdown"
        :previewImage="previewImage"
        :isSuccess="success"
        :isShown="previewImage && !isInProgress"
        @onTryAgain="takePicture"
        @onNext="handleSubmit"
      />

      <div class="body__container--card">
        <div>
          <div class="thin-line" />
          <p>Vamos tirar uma foto para identificar você.</p>
        </div>
        <CameraButtonGroup @onCallReception="callReception" />
      </div>
    </div>

      <FeedbackModal
        v-if="isOpenModal"
        :isSuccess="success"
        :message="message"
        :isNonScheduled="true"
        @onClose="closeModal"
        @onTryAgain="takePicture"
        attempts="3"
        :type="feedbackType"
      />
    <Loading v-if="this.$store.state.isLoading" />
</div>
</template>

<script>
import CameraButtonGroup from "../components/CameraButtonGroup.vue";
import CameraDisplay from "../components/CameraDisplay.vue";
import CompanyHeader from "../components/Departments/CompanyHeader.vue";
import FeedbackCard from "../components/FeedbackCard.vue";
import Loading from "../components/Loading.vue";
import CompanyService from "../services/CompanyService";
import TotemService from "../services/TotemService";
import FeedbackNotification from "./../components/FeedbackModal.vue";
import FeedbackModal from "./../components/FeedbackModal.vue";

export default {
  data() {
    return {
      isLoading: false,
      isOpenModal: false,
      companyService: new CompanyService(),
      totemService: new TotemService(),
      currentCompany: null,
      videoStream: null,
      countdown: 5,
      previewImage: null,
      success: null,
      imgFile: null,
      isInProgress: false,
      message: "",
      feedbackType: '',
      companyId: this.$route.params.id,
    };
  },
  components: {
    Loading,
    CompanyHeader,
    FeedbackCard,
    FeedbackNotification,
    CameraDisplay,
    CameraButtonGroup,
    FeedbackModal,
  },
  methods: {
    defaultProgressState() {
      this.success = null;
      this.message = "";
      this.isOpenModal = false;
    },
    closeModal() {
      this.defaultProgressState();
      this.isInProgress = false;
      this.isOpenModal = false;
      this.feedbackType = '';
    },
    createPayload() {
      const storeData = this.$store.state.schedule;

      const formData = new FormData();
      formData.append("nome_visitante", storeData.name);
      formData.append("id_instituicao", this.companyId);
      formData.append("id_setor", storeData.department);
      formData.append("motivo_visita", storeData.reason);
      formData.append("foto_visitante", storeData.photo);

      return formData;
    },
    clearStoreData() {
      this.$store.commit("setScheduleCompany", {});
      this.$store.commit("setScheduleDepartment", {});
      this.$store.commit("setScheduleReason", "");
      this.$store.commit("setSchedulePhoto", "");
      this.$store.commit("setScheduleName", "");
    },
    onErrorRedirect(){
      this.$router.push({ name: "non-scheduled" });
    },
    async handleSubmit() {
      if(!this.verifyStoreData()) return;

      const payload = this.createPayload();

      this.$store.commit('setIsLoading', true);
      await this.notifyVisitor(payload);
      this.$store.commit('setIsLoading', false);
    },
    async notifyVisitor(payload) {
      await this.companyService
        .nonScheduledVisitors(payload)
        .then((response) => {
          this.toggleFeedbackModal();
          this.validateSuccess();
          // this.clearStoreData();
        })
        .catch((error) => {
          console.error("Erro ao enviar notificação:", error);
          this.success = false;
          this.message = "Erro ao enviar notificação. Tente novamente.";
          this.toggleFeedbackModal();
        });
    },
    async getCompanies() {
      await this.companyService
        .getCompanies()
        .then((response) => {
          this.companies = response.data;
          this.currentCompany = this.companies.find(
            (company) => company.id_instituicao === this.companyId
          );
        })
        .catch((error) => {
          console.error("Erro ao buscar empresas:", error);
        });
    },
    async startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false,
        });
        this.videoStream = stream;
        this.$refs.cameraDisplay.$refs.videoElement.srcObject = stream;
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
      }
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
      }
    },
    verifyStoreData() {
      const storeData = this.$store.state.schedule;
      if (
        !storeData.company ||
        !storeData.department ||
        !storeData.reason ||
        !storeData.name
      ) {
        this.isOpenModal = true;
        this.success = false;
        this.message = "Dados incompletos. Você será redirecionado à tela inicial.";
          setTimeout(() => {
            this.onErrorRedirect();
            this.toggleFeedbackModal();
          }, 4000);
        return false;
      }else{
        return true;
      }
    },
    startCountdown() {
      const countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(countdownInterval);
          this.captureImage();
        }
      }, 1000);
    },
    captureImage() {
      const canvas = document.createElement("canvas");
      canvas.width = this.$refs.cameraDisplay.$refs.videoElement.videoWidth;
      canvas.height = this.$refs.cameraDisplay.$refs.videoElement.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(this.$refs.cameraDisplay.$refs.videoElement, 0, 0);
      canvas.toBlob((blob) => {
        const file = new File([blob], "user.png", {
          type: "image/png",
          lastModified: Date.now(),
        });
        const url = URL.createObjectURL(file);
        this.imgFile = file;
        this.previewImage = url;
        this.$store.commit("setSchedulePhoto", file);
      }, "image/png");

      this.stopCamera();
    },
    validateSuccess(name) {
      this.success = true;
      this.isInProgress = false;
        // this.$router.push({ name: name});
    },
    async takePicture() {
      this.defaultProgressState();
      this.isInProgress = false;
      this.previewImage = null;
      this.countdown = 5;
      await this.startCamera();
      this.startCountdown();
    },
    setCurrentCompany() {
      const company = this.$store.state.schedule.company;
      if (company) {
        this.currentCompany = company;
      } else {
        this.getCompanies();
      }
    },
    async callReception() {
      this.$store.commit('setIsLoading', true);

      const payload = {
        id_instituicao: this.companyId,
      };

      await this.companyService
        .callReception(payload)
        .then((response) => {
          this.success = true;
          this.feedbackType = 'reception';
          this.toggleFeedbackModal();
        })
        .catch((error) => {
          console.error("Erro ao buscar empresas:", error);
          this.success = false;
          this.message = "Erro ao chamar recepção. Tente novamente.";
          this.toggleFeedbackModal();
        });
      this.$store.commit('setIsLoading', false);
    },
    toggleFeedbackModal() {
      this.isOpenModal = !this.isOpenModal;
    },
  },
  computed: {
    hintText() {
      return this.success
        ? "Tudo pronto. "
        : "Vamos tirar uma foto para identificar você.";
    },
  },
  async mounted() {
    this.$store.commit('setIsLoading', true);
    this.setCurrentCompany();
    this.takePicture();
    this.$store.commit('setIsLoading', false);
  },
  beforeDestroy() {
    this.stopCamera();
  },
};
</script>
<style scoped>
.loading-access {
  position: fixed;
  top: 56%;
  left: 40%;
  /* right: 0;
  bottom: 0; */
  color: #44120a;
  font-size: 1.2vw;
  font-weight: bold;
  z-index: 99999999;
}

.page-container {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}

.body__container {
  height: 70%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.body__container--card {
  background-color: #ffffff;
  width: 100%;
  height: 110%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  padding: 70px 60px;

  p {
    color: #838383;
    text-align: justify;
    width: 70%;
    font-size: 1.2vw;
  }
}

.thin-line {
  border-bottom: 2px solid #de3012;
  width: 20%;
  height: 20px;
  display: flex;
  justify-content: start;
  align-items: start;
  margin: 10px 0px;
}

.form-container {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: start;
  align-items: start;
  /* background-color: #ffffff; */
  position: absolute;
}

.form-container--input {
  width: 35%;
  height: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #edf0f8;
  border-left: 8px solid #e76752;

  .input-field {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: none;
    padding: 10px 20px;
    font-size: 1vw;
    font-weight: medium;
    color: #838383;
    background-color: #edf0f8;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.145);
    outline: none;
    transition: all 0.3s ease;

    &:focus {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
      /* transform: scale(1.05); */
      cursor: pointer;
      transition: all 0.3s ease;
    }
  }

  option {
    color: #838383;
    font-size: 1vw;
    font-weight: medium;
  }
}

.loading-feed {
  display: flex;
}
</style>
